import { TargetBasketRow } from "./table";
import { SearchChemistryGroups } from "contexts/search/context";
import { usePeriodIndex } from "hooks/periodIndex";
import { useTargetBaskets } from "hooks/search";
import { useProductionBasketRowUpdater } from "components/targetBaskets/useProductionBasketRowUpdater";
import { useCallback } from "react";

export const useHandleTableMutations = (
  maxBaskets: number,
  chemistryGroups: SearchChemistryGroups
) => {
  const periodTab = usePeriodIndex();
  const [, setTargetBaskets] = useTargetBaskets(periodTab);
  const getDefaultValue = useCallback(
    (row: TargetBasketRow) =>
      chemistryGroups.byId[row.groupId]?.default_target_num_baskets ?? 0,
    [chemistryGroups]
  );
  const handleValidValue = useCallback(
    (row: TargetBasketRow, value: number) => {
      setTargetBaskets((current) => [
        ...current.filter((item) => item.chef_group_id !== row.groupId),
        {
          chef_group_id: row.groupId,
          target_num_baskets: value,
        },
      ]);
    },
    [setTargetBaskets]
  );

  const handleUpdateItem = useProductionBasketRowUpdater<TargetBasketRow>({
    maxTarget: maxBaskets > 0 ? maxBaskets : undefined,
    getDefaultValue,
    onValidValue: handleValidValue,
  });

  return { handleUpdateItem };
};
